import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingCTAs from "@/components/FloatingCTAs";
import CookieBanner from "@/components/CookieBanner";
import CommandPalette from "@/components/CommandPalette";
import { Outlet } from "react-router-dom";

export default function Layout() {
  return (
    <div className="min-h-screen bg-ink-950 text-white font-body">
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <FloatingCTAs />
      <CookieBanner />
      <CommandPalette />
    </div>
  );
}
